import { useState } from 'react'
import { T } from '../lib/tokens'
import { useArchivedItems, useTrashedItems, useUpdateItemStatus } from '../lib/hooks'
import { Sidebar } from '../components/Sidebar'
import { Topbar } from '../components/Topbar'
import { CatBadge, TimeAgo, LoadingSpinner } from '../components/ui'

type Tab = 'archive' | 'trash'

export function ArchivePage() {
  const [tab, setTab] = useState<Tab>('archive')
  const { data: archived = [], isLoading: loadingArchive } = useArchivedItems()
  const { data: trashed = [], isLoading: loadingTrash } = useTrashedItems()
  const { mutate: updateStatus, isPending } = useUpdateItemStatus()

  const items = tab === 'archive' ? archived : trashed
  const isLoading = tab === 'archive' ? loadingArchive : loadingTrash

  return (
    <div style={{ display:'flex',height:'100dvh',background:T.bg,color:T.text,fontFamily:T.font,overflow:'hidden' }}>
      <Sidebar />
      <div style={{ flex:1,display:'flex',flexDirection:'column',overflow:'hidden' }}>
        <Topbar />
        <main style={{ flex:1,overflowY:'auto',padding:'28px 28px 40px' }}>
          <h2 style={{ fontSize:18,fontWeight:700,color:T.text,margin:'0 0 20px' }}>アーカイブ & ゴミ箱</h2>

          {/* タブ */}
          <div style={{ display:'flex',gap:4,marginBottom:24,borderBottom:`1px solid ${T.border}`,paddingBottom:0 }}>
            {([['archive','□ アーカイブ',archived.length],['trash','🗑 ゴミ箱',trashed.length]] as const).map(([id,label,count])=>(
              <button key={id} onClick={()=>setTab(id)} style={{
                padding:'8px 16px',background:'transparent',border:'none',
                borderBottom:`2px solid ${tab===id?T.accent:'transparent'}`,
                color:tab===id?T.text:T.textDim,fontSize:13,cursor:'pointer',
                fontFamily:T.font,marginBottom:-1,transition:'color 0.12s',
              }}>
                {label} <span style={{ fontSize:10,fontFamily:T.fontMono,color:T.textMute,marginLeft:4 }}>{count}</span>
              </button>
            ))}
          </div>

          {isLoading && <LoadingSpinner />}

          {!isLoading && items.length === 0 && (
            <div style={{ padding:'60px 0',textAlign:'center',color:T.textMute,fontSize:13 }}>
              {tab==='archive'?'アーカイブされたアイテムはありません':'ゴミ箱は空です'}
            </div>
          )}

          <div style={{ display:'flex',flexDirection:'column',gap:8 }}>
            {items.map(item => (
              <div key={item.id} style={{
                background:T.bgRaised,border:`1px solid ${T.border}`,
                borderRadius:8,padding:'12px 16px',
                display:'flex',alignItems:'center',gap:12,
              }}>
                <div style={{ flex:1,display:'flex',flexDirection:'column',gap:5,overflow:'hidden' }}>
                  <div style={{ display:'flex',alignItems:'center',gap:8,flexWrap:'wrap' }}>
                    <CatBadge catId={item.cat_id} />
                    <span style={{ fontSize:10,fontFamily:T.fontMono,color:T.textMute }}>{item.kind}</span>
                    <TimeAgo iso={item.created_at} />
                  </div>
                  <div style={{ fontSize:13,fontWeight:500,color:T.text,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>
                    {item.title??item.original_content.slice(0,80)}
                  </div>
                  {item.summary && (
                    <div style={{ fontSize:11,color:T.textDim,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>
                      {item.summary}
                    </div>
                  )}
                </div>

                {/* アクションボタン */}
                <div style={{ display:'flex',gap:6,flexShrink:0 }}>
                  {tab==='archive' && (
                    <>
                      <ActionBtn label="復元" onClick={()=>updateStatus({id:item.id,status:'done'})} disabled={isPending} />
                      <ActionBtn label="削除" danger onClick={()=>updateStatus({id:item.id,status:'trashed'})} disabled={isPending} />
                    </>
                  )}
                  {tab==='trash' && (
                    <>
                      <ActionBtn label="復元" onClick={()=>updateStatus({id:item.id,status:'done'})} disabled={isPending} />
                      <ActionBtn label="アーカイブへ" onClick={()=>updateStatus({id:item.id,status:'archived'})} disabled={isPending} />
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  )
}

function ActionBtn({ label, onClick, danger, disabled }: { label:string;onClick:()=>void;danger?:boolean;disabled?:boolean }) {
  return (
    <button onClick={onClick} disabled={disabled} style={{
      padding:'5px 12px',borderRadius:5,fontSize:11,cursor:disabled?'not-allowed':'pointer',
      background:'transparent',fontFamily:'inherit',transition:'all 0.12s',
      border:`1px solid ${danger?T.warn+'60':T.border}`,
      color:danger?T.warn:T.textDim,
      opacity:disabled?0.5:1,
    }}>{label}</button>
  )
}
